function carousel(name) {
    document.querySelectorAll(name).forEach(
        carousel => new Splide(carousel, {
            pagination: true,
            arrows: true,
            type: 'loop',
            autoplay: true,
            rewind: true,
            pauseOnHover: false,
            pauseOnFocus: false
        }
    ).mount());

    //var toggleButton = splide.root.querySelector('.splide__toggle');

    //splide.on('autoplay:play', function () {
    //    toggleButton.setAttribute('aria-label', 'Pause autoplay');
    //});

    //splide.on('autoplay:pause', function () {
    //    toggleButton.setAttribute('aria-label', 'Start autoplay');
    //});
}